import TSAbstractEntity from './TSAbstractEntity';

export default class TSFile extends TSAbstractEntity {

    private _filename: string;

    private _filesize: string;

    private _filetype: string;

    get filename(): string {
        return this._filename;
    }

    set filename(value: string) {
        this._filename = value;
    }

    get filesize(): string {
        return this._filesize;
    }

    set filesize(value: string) {
        this._filesize = value;
    }

    get filetype(): string {
        return this._filetype;
    }

    set filetype(value: string) {
        this._filetype = value;
    }

    deserialize(restObject: any): TSFile {
        super.deserialize(restObject);
        this.filename = restObject.filename;
        this.filesize = restObject.filesize;
        this.filetype = restObject.filetype;
        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.filename = this.filename;
        restObject.filesize = this.filesize;
        restObject.filetype = this.filetype;
        return restObject;
    }
}





// WEBPACK FOOTER //
// ./src/app/models/TSFile.ts